import firebase from 'firebase/app';

export const traverse = (
  obj: any,
  visitor: (path: (string | number)[], value: any) => void,
  path: (string | number)[] = []
) => {
  if (Array.isArray(obj)) {
    obj.forEach((v, i) => {
      const nextPath = [...path, i];
      traverse(v, visitor, nextPath);
    });
    return;
  }

  if (typeof obj === 'function') {
    visitor(path, obj);
    return;
  }

  if (typeof obj === 'object' && obj !== null) {
    Object.entries(obj).forEach(([k, v]) => {
      const nextPath = [...path, k];
      traverse(v, visitor, nextPath);
    });
    return;
  }

  visitor(path, obj);
};

export const traverseTimestampAware = (
  obj: any,
  visitor: (path: (string | number)[], value: any) => void,
  path: (string | number)[] = []
) => {
  if (Array.isArray(obj)) {
    obj.forEach((v, i) => {
      const nextPath = [...path, i];
      traverseTimestampAware(v, visitor, nextPath);
    });
    return;
  }

  if (typeof obj === 'function') {
    visitor(path, obj);
    return;
  }

  if (obj instanceof firebase.firestore.Timestamp) {
    visitor(path, obj);
    return;
  }

  if (typeof obj === 'object' && obj !== null) {
    Object.entries(obj).forEach(([k, v]) => {
      const nextPath = [...path, k];
      traverseTimestampAware(v, visitor, nextPath);
    });
    return;
  }

  visitor(path, obj);
};

/**
 * Traverse and object and find undefined fields, throws an error if undefined fields are discovered
 */
export const checkAndReportUndefined = (
  obj: any,
  objName: string = 'document'
): void => {
  const undefinedFields: any = [];

  traverse(obj, (path, value) => {
    if (value === undefined) {
      undefinedFields.push({
        fullPath: path.join('.'),
        pathArray: [...path]
      });
    }
  });

  if (undefinedFields.length > 0) {
    console.error(`Found undefined fields in ${objName}:`);
    undefinedFields.forEach(({ fullPath }: any) => {
      console.error(`${fullPath}`);
    });

    const error = new Error(
      `${objName} contains ${undefinedFields.length} undefined fields`
    );
    (error as any).undefinedFields = undefinedFields;
    (error as any).objName = objName;
    throw error;
  }
};

export const sanitizeUndefined = (obj: any): void => {
  traverse(obj, (path, value) => {
    if (value === undefined) {
      const lastKey = path[path.length - 1];
      let parent = obj;

      for (let i = 0; i < path.length - 1; i++) {
        parent = parent[path[i]];
      }

      if (parent && typeof lastKey !== 'undefined') {
        parent[lastKey] = null;
      }
    }
  });
};
